import { registerQuery } from 'data-fetching-client';
import { default as httpClient } from 'hub-http/clients/apiClient';
import { getInferenceHubTierRpc } from 'personalization-service-types';
import { createRpcClientV2 } from 'rpc-client-utils';
export const rpcClient = createRpcClientV2({
  hubHttpClient: httpClient
});
export const GET_RECOMMENDED_API_V2 = registerQuery({
  fieldName: 'recommendedApiV2',
  args: ['hubTypes', 'tierTypes'],
  async fetcher({
    hubTypes,
    tierTypes
  }) {
    const queryParameters = Object.assign({}, hubTypes && hubTypes.length ? {
      hubs: hubTypes
    } : {
      hubs: null
    }, tierTypes && tierTypes.length ? {
      tier: tierTypes
    } : {
      tier: null
    });
    return await rpcClient.call(getInferenceHubTierRpc, {
      queryParameters
    });
  }
});